export enum SidebarOrigin {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
